import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiPost } from './api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);
  const navigate = useNavigate();

  const fazerLogin = async (e) => {
    e.preventDefault();
    if (enviando) return;
    setErro('');
    setEnviando(true);

    try {
      const dados = await apiPost('/login.php', { email, senha });

      if (dados.sucesso) {
        // Salva o "crachá" no seu navegador e vai pro Painel
        localStorage.setItem('unity_token', dados.token);
        navigate('/dashboard');
      } else {
        setErro(dados.mensagem);
      }
    } catch (e) {
      setErro('Erro de conexão. Tente novamente.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div style={{ display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f9fafb' }}>
      <div style={{ background: 'white', padding: '40px', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)', width: '350px' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Unity Makers</h2>
        <form onSubmit={fazerLogin} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          
          <input 
            type="email" 
            placeholder="E-mail" 
            value={email} 
            onChange={e => setEmail(e.target.value)} 
            required 
            style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '5px' }}
          />
          
          <input 
            type="password" 
            placeholder="Senha" 
            value={senha} 
            onChange={e => setSenha(e.target.value)} 
            required 
            style={{ padding: '10px', border: '1px solid #ccc', borderRadius: '5px' }}
          />
          
          {erro && <p style={{ color: 'red', fontSize: '14px', margin: 0 }}>{erro}</p>}
          
          <button type="submit" disabled={enviando} style={{ padding: '12px', background: 'black', color: 'white', border: 'none', borderRadius: '5px', cursor: enviando ? 'default' : 'pointer', fontWeight: 'bold', opacity: enviando ? 0.6 : 1 }}>
            {enviando ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}